import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioComponent {
  @Input() value: string;
  @Output() change = new EventEmitter<string>();

  isSelected = false;
  isDisabled = false;

  constructor(private cdr: ChangeDetectorRef) {}

  select() {
    if (this.isDisabled) return;
    this.change.emit(this.value);
  }

  setSelected(selected: boolean): void {
    this.isSelected = selected;
    this.cdr.markForCheck();
  }

  setDisabled(disabled: boolean): void {
    this.isDisabled = disabled;
    this.cdr.markForCheck();
  }
}
